import { Miljo } from './../../../models/miljo';
import RequestService from '../requestService';
import { client } from '../../client';
import { FilLagerInfoDummy } from '../../../models/filLagerInfoDummy';

export default class MiljoService extends RequestService<Miljo,'miljo'> {
    constructor() {
        super('miljo');
    }

    fetchProviders = async (miljoId: number) =>client.get<FilLagerInfoDummy>( `${this.serviceName}/${encodeURIComponent(miljoId)}/providers` );
}
